import { useMutation } from 'react-query';
import { TemplateType } from 'types/narrative/narrative.types';

import { testNarrativeText as mutationFn } from 'api/endPoints/testNarrativeText';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useMutationTestNarrativeText = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    compareMetaDataId: number;
    actualMetaDataId: number;
    narrativeText: string;
    componentKey: string;
    templateType: TemplateType;
    filter: {
        filters: IFilter[] | undefined;
    };
}
